module.exports = __webpack_public_path__ + "img/unit-usaha-syariah-pt-orion-penjaminan-indonesia.44e046bb.png";